import React from 'react'
import Show from 'services/Show';
import { formatDate } from 'services/utils'
import { Spinner } from 'components/atoms';
import { Tabs, Tab } from 'components/Tabs';
import DogsByFCIGroup from 'components/DogsByFCIGroup';

const fciGroups = [1,2,3,4,5,6,7,8,9,10,0];

export default class ShowDogs extends React.Component {
  constructor({ props, match }) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      show: {},
      dogs: [],
      breeds: [],
      showId: match.params.id,
      filledFciGroups: [],
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this.setState({loading: true});
    Show.getDogs(this.state.showId).then(({show, dogs, breeds}) => {
      let filledFciGroups = {};
      breeds.forEach(breed => {
        filledFciGroups[breed.fci_group] = true;
      });
      this.setState({ show: new Show(show), dogs, breeds, filledFciGroups });
    }).catch(alert).then(() => this.setState({loading: false}) );
  }

  numberDogs = () => {
    if (this.state.show) {
      this.setState({loading: true});
      this.state.show.numberDogs().then(() => {
        this.loadData();
      }).catch(alert).then(() => this.setState({loading: false}) );
    }
  }

  onCancel = () => {
    this.props.history.goBack()
  }

  toggleOpen = () => {
    this.setState({open: !this.state.open});
  }

  render() {
    const {show, dogs, breeds, filledFciGroups, open, loading} = this.state;
    let showInfo = null;
    if (show) {
      showInfo = (
        <span className="show">
          <span className="show-date"> {formatDate(show.starts_at)} </span>
          <i> / </i>
          <strong className="show-name"> {show.name} </strong>
        </span>
      )
    }
    const filteredGroups = fciGroups.filter(group => filledFciGroups[group]);
    const dogsInTabs = filteredGroups.map(groupNum => {
      const title = groupNum ? `${groupNum} гр. FCI` : 'Вне классификации';
      return (
        <Tab key={groupNum} title={title}>
          <div className="custom-control custom-switch ms-3">
            <input type="checkbox" name="open" checked={open} onChange={this.toggleOpen} 
              className="custom-control-input" id="openSwitch" />
            <label className="custom-control-label" htmlFor="openSwitch">{open ? 'Всё открыто' : 'закрыто'}</label>
          </div>
          <DogsByFCIGroup dogs={dogs} breeds={breeds} group={groupNum} open={open} />
        </Tab>
      );
    });

    return (
      <div className="container-fluid">
        <h4>Каталог выставки - {showInfo}</h4>
        {loading && <Spinner /> }
        {dogs.length > 1 ? <button onClick={this.numberDogs} className="btn btn-info m-3" >Пронумеровать собак для каталога</button> : null}

        <Tabs>{dogsInTabs}</Tabs>

      </div>
    );
  }
}

